import { render, staticRenderFns } from "./LegalMtr.vue?vue&type=template&id=3ac9de0f&scoped=true&"
import script from "./LegalMtr.vue?vue&type=script&lang=js&"
export * from "./LegalMtr.vue?vue&type=script&lang=js&"
import style0 from "./LegalMtr.vue?vue&type=style&index=0&id=3ac9de0f&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ac9de0f",
  null
  
)

export default component.exports